import { makeOrientationAck } from './orientation-ack'
import type { TutorialStep } from '@/shared/components/tutorial/types'

/**
 * Shared first step prepended to every role tutorial (owner / manager /
 * reception). Role-agnostic: tells the operator clubmanager runs best on a
 * desktop and can be installed as an app, and deep-links to the install
 * instructions (Ajustes → Instalación).
 *
 * Completion is "installed OR seen once": the picker passes
 * `platformWelcomeDone = isStandalone() || isPlatformWelcomeSeen()` into
 * every tutorial ctx (keeping `isComplete` a pure function of ctx, per the
 * tutorial-primitive contract). `onActivate` fires when the operator opens
 * the install instructions from the step, persisting the ack so the FAB can
 * still self-extinguish for desktop-browser users who will never install.
 */

const installAck = makeOrientationAck('platform.install')
export const isPlatformWelcomeSeen = installAck.is
export const markPlatformWelcomeSeen = installAck.mark

/**
 * The shared step, generic over any ctx that carries `platformWelcomeDone`.
 * Each role tutorial adds that field to its ctx and prepends
 * `platformWelcomeStep<ItsCtx>()` as step 1.
 */
export function platformWelcomeStep<
  Ctx extends { platformWelcomeDone: boolean },
>(): TutorialStep<Ctx> {
  return {
    id: 'platform-welcome',
    label: 'Instala la app',
    hint: 'Funciona mejor en pantalla amplia. Desde Ajustes → Instalación te explicamos cómo.',
    isComplete: (ctx) => ctx.platformWelcomeDone,
    deepLink: { label: 'Ver instalación', to: '/settings?tab=install' },
    onActivate: markPlatformWelcomeSeen,
  }
}
